module.exports = __webpack_public_path__ + "img/071.4bf14988.jpeg";